import './css/main.css';


import barba from '@barba/core';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

// import 'vidstack/player';
// import 'vidstack/player/layouts/default';
// import 'vidstack/player/ui';

// Expose barba globally for use in other modules
window.barba = barba;

barba.init({
  debug: true,
  timeout: 7000,
  transitions: [
    {
      name: 'opacity-transition',
      leave(data) {
        return gsap.to(data.current.container, {
          opacity: 0
        });
      },
      // * MA added this beforeEntry bit
      beforeEnter: function beforeEnter(data) {},
      enter(data) {},
      after(data) {
        return gsap.from(data.next.container, {
          opacity: 0
        });
      },
      afterOnce(data) {},
      once(data) {}
    }
  ]
});

function scrollToTop() {
  // window.scrollTo({top: 0, behavior: 'smooth'});
  window.scrollTo({ top: 0 });
}

history.scrollRestoration = "manual";
let scrollPosY = [0];

function menuHighlight(data) {
  import(/* webpackChunkName: "menuHighlight" */ "./js/components/menuHighlight.js").then(module => {
    const highlightIt = module.default;
    highlightIt(data);
  });
}

function bgColour(data) {
  import(/* webpackChunkName: "bgColour" */ "./js/components/bgColour.js").then(module => {
    const colourIt = module.default;
    colourIt(data);
  });
}


function hamburgerToggle(preset) {
    import(/* webpackChunkName: "hamburgerToggle" */ "./js/components/hamburgerToggle.js").then(module => {
      const toggle = module.default;
      toggle(preset);
    });
  }

function initHeroCarousel() {
  if (!document.querySelector('.heroCarousel')) return;

  import(/* webpackChunkName: "heroCarousel" */ "./js/components/heroCarousel.js").then(module => {
    const initCarousel = module.default;
    initCarousel();
  });
}

function destroyHeroCarousel() {
  if (!document.querySelector('.heroCarousel')) return;

  import(/* webpackChunkName: "heroCarousel" */ "./js/components/heroCarousel.js").then(module => {
    const destroy = module.destroyHeroCarousel;
    if (destroy) destroy();
  });
}

function initServicesMarquee() {
  if (!document.querySelector('.servicesRotatingGrid')) return;

  import(/* webpackChunkName: "servicesMarquee" */ "./js/components/servicesMarquee.js").then(module => {
    const initMarquee = module.default;
    initMarquee();
  });
}

function destroyServicesMarquee() {
  import(/* webpackChunkName: "servicesMarquee" */ "./js/components/servicesMarquee.js").then(module => {
    const destroy = module.destroyServicesMarquee;
    if (destroy) destroy();
  });
}

function initProjectCarousel() {
  if (!document.querySelector('.projectCarousel')) return;

  import(/* webpackChunkName: "projectCarousel" */ "./js/components/projectCarousel.js").then(module => {
    const initCarousel = module.default;
    initCarousel();
  });
}

function destroyProjectCarousel() {
  if (!document.querySelector('.projectCarousel')) return;

  import(/* webpackChunkName: "projectCarousel" */ "./js/components/projectCarousel.js").then(module => {
    const destroy = module.destroyProjectCarousel;
    if (destroy) destroy();
  });
}

function initGetTermsEmbed() {
  if (!document.querySelector('.getterms-document-embed')) return;

  import(/* webpackChunkName: "getTermsEmbed" */ "./js/components/getTermsEmbed.js").then(module => {
    module.default();
  });
}

function initProjectFilters() {
  import(/* webpackChunkName: "projectFilters" */ "./js/components/projectFilters.js").then(module => {
    const initFilters = module.default;
    initFilters();
  });
}

function destroyProjectFilters(leavingProjects = false) {
  import(/* webpackChunkName: "projectFilters" */ "./js/components/projectFilters.js").then(module => {
    const destroy = module.destroyProjectFilters;
    if (destroy) destroy(leavingProjects);
  });
}

function initLocationsMap() {
  if (!document.getElementById('locationsMap')) return;

  import(/* webpackChunkName: "locationsMap" */ "./js/components/locationsMap.js").then(module => {
    const initMap = module.default;
    initMap();
  });
}

function destroyLocationsMap() {
  if (!document.getElementById('locationsMap')) return;

  import(/* webpackChunkName: "locationsMap" */ "./js/components/locationsMap.js").then(module => {
    const destroy = module.destroyLocationsMap;
    if (destroy) destroy();
  });
}

function initJournalFilters() {
  import(/* webpackChunkName: "journalFilters" */ "./js/components/journalFilters.js").then(module => {
    const initFilters = module.default;
    initFilters();
  });
}

function destroyJournalFilters(leavingJournal = false) {
  import(/* webpackChunkName: "journalFilters" */ "./js/components/journalFilters.js").then(module => {
    const destroy = module.destroyJournalFilters;
    if (destroy) destroy(leavingJournal);
  });
}

let filterBarFooterStickyCleanup = null;

function initFilterBarFooterSticky() {
  // Clear any existing cleanup first
  if (filterBarFooterStickyCleanup) {
    filterBarFooterStickyCleanup();
    filterBarFooterStickyCleanup = null;
  }

  import(/* webpackChunkName: "filterBarFooterSticky" */ "./js/components/filterBarFooterSticky.js").then(module => {
    const initSticky = module.default;
    const cleanup = initSticky();
    // Only store cleanup if it's a function
    if (typeof cleanup === 'function') {
      filterBarFooterStickyCleanup = cleanup;
    }
  });
}

function destroyFilterBarFooterSticky() {
  if (filterBarFooterStickyCleanup && typeof filterBarFooterStickyCleanup === 'function') {
    filterBarFooterStickyCleanup();
    filterBarFooterStickyCleanup = null;
  }
}

function initSpotlightParallax() {
  if (!document.querySelector('.spotlightBlock')) return;

  import(/* webpackChunkName: "spotlightParallax" */ "./js/components/spotlightParallax.js").then(module => {
    const init = module.default;
    init();
  });
}

function destroySpotlightParallax() {
  if (!document.querySelector('.spotlightBlock')) return;

  import(/* webpackChunkName: "spotlightParallax" */ "./js/components/spotlightParallax.js").then(module => {
    const destroy = module.destroySpotlightParallax;
    if (destroy) destroy();
  });
}

function initStoryLinkHover() {
  if (!document.getElementById('ourStoryPage')) return;

  import(/* webpackChunkName: "storyLinkHover" */ "./js/components/storyLinkHover.js").then(module => {
    const init = module.default;
    init();
  });
}

function destroyStoryLinkHover() {
  if (!document.getElementById('ourStoryPage')) return;

  import(/* webpackChunkName: "storyLinkHover" */ "./js/components/storyLinkHover.js").then(module => {
    const destroy = module.destroyStoryLinkHover;
    if (destroy) destroy();
  });
}

let hamburgerOuter = document.getElementById("hamburgerOuter");
if (hamburgerOuter) {
  hamburgerOuter.addEventListener("click", function() {hamburgerToggle()});
}

// ── Enquiry Overlay ──────────────────────────────────────────
// Lazy-load the module on first open; subsequent calls reuse the cached chunk.

function openEnquiryOverlay() {
  import(/* webpackChunkName: "enquiryOverlay" */ "./js/components/enquiryOverlay.js").then(module => {
    module.default();
  });
}

const getTouchBtn = document.getElementById("getTouchButton");
if (getTouchBtn) {
  getTouchBtn.addEventListener("click", openEnquiryOverlay);
}

const enquiryMenuBtn = document.getElementById("enquiryTriggerMenu");
if (enquiryMenuBtn) {
  enquiryMenuBtn.addEventListener("click", () => {
    // Close hamburger menu first, then open enquiry overlay after animation
    hamburgerToggle("c");
    setTimeout(openEnquiryOverlay, 350);
  });
}

barba.hooks.once(data => {
  menuHighlight(data);
  // bgColour(data);
});

barba.hooks.afterOnce(data => {
  initHeroCarousel();
  initServicesMarquee();
  initProjectCarousel();
  initProjectFilters();
  initJournalFilters();
  initLocationsMap();
  initFilterBarFooterSticky();
  initSpotlightParallax();
  initStoryLinkHover();
  initGetTermsEmbed();
});

barba.hooks.before(data => {
  if(data.trigger !== "back") {
    scrollPosY.push(barba.history.current.scroll.y);
    // console.log(barba.history.current.scroll.y)
    // console.log(scrollPosY)
  }
  hamburgerToggle('c');
  destroyHeroCarousel();
  destroyServicesMarquee();
  destroyProjectCarousel();
  destroyLocationsMap();
  destroyFilterBarFooterSticky();
  destroySpotlightParallax();
  destroyStoryLinkHover();

  // Close dropdowns/drawer only — the after hook handles show/hide with correct namespace data
  destroyProjectFilters(false);
  destroyJournalFilters(false);

});

barba.hooks.enter(data => {
  
  
});

barba.hooks.beforeEnter(data => {
  // scrollToTop();
  // bgColour(data);
  
});

barba.hooks.after(data => {
  // HubSpot SPA page view — push after URL has updated
  const _hsq = window._hsq = window._hsq || [];
  _hsq.push(['setPath', window.location.pathname + window.location.search]);
  _hsq.push(['trackPageView']);

  // subMenuToggle('open');
  if(data.trigger !== "back") {
    window.scrollTo(0,0);
  } else {
    setTimeout(() => {window.scrollTo(0, scrollPosY.pop())}, 100);
    // console.log(scrollPosY)
  }

  // Hide/show filter bars based on new page needs - do this FIRST
  const needsProjectFilterBar = data.next.container.dataset.showProjectFilterBar === 'true';
  const needsJournalFilterBar = data.next.container.dataset.showJournalFilterBar === 'true';
  const projectFilterBar = document.getElementById('projectFilterBar');
  const journalFilterBar = document.getElementById('journalFilterBar');

  // Handle project filter bar
  if (!needsProjectFilterBar && projectFilterBar && !projectFilterBar.classList.contains('hidden')) {
    projectFilterBar.classList.add('opacity-0');
    setTimeout(() => {
      projectFilterBar.classList.add('hidden');
      projectFilterBar.classList.add('invisible');
    }, 300);
  }

  // Handle journal filter bar
  if (!needsJournalFilterBar && journalFilterBar && !journalFilterBar.classList.contains('hidden')) {
    journalFilterBar.classList.add('opacity-0');
    setTimeout(() => {
      journalFilterBar.classList.add('hidden');
      journalFilterBar.classList.add('invisible');
    }, 300);
  }

  menuHighlight(data);
  initHeroCarousel();
  initServicesMarquee();
  initProjectCarousel();
  initProjectFilters();
  initJournalFilters();
  initLocationsMap();
  initFilterBarFooterSticky();
  initSpotlightParallax();
  initStoryLinkHover();
  initGetTermsEmbed();
});
